"use strict";
/**
 * CALL-04 / CALL-16 (Anthony's call, 2026-10-23; Paul, 2026-10-26): the iPhone app sells
 * through web checkout, not in-app purchase. "Continue to checkout" opens Stripe Checkout in
 * Safari, which is allowed on the United States storefront (App Review 3.1.1(a)). These are
 * the words around that link-out, kept here so both clients say the same thing if web ever
 * renders the native flow (rule 17).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKOUT_CHECK_AGAIN_COPY = exports.CHECKOUT_BACK_COPY = exports.CHECKOUT_LINK_OUT_NOTE_COPY = exports.CHECKOUT_LINK_OUT_BUTTON_COPY = void 0;
/** The plan screen's button where checkout opens in the system browser. */
exports.CHECKOUT_LINK_OUT_BUTTON_COPY = "Continue to checkout";
/** Under the button: where the purchase happens, said before the app is left. */
exports.CHECKOUT_LINK_OUT_NOTE_COPY = "You'll finish with Stripe in Safari, then come back to Fomo-Fi.";
/**
 * Shown once the user is back from the browser and the server doesn't yet say they're
 * subscribed. The app can't tell a finished checkout whose confirmation is still on its way
 * from an abandoned one, so this claims neither ("nothing was charged" belongs only to
 * Stripe's own Cancel return).
 */
exports.CHECKOUT_BACK_COPY = "Back from checkout? If you finished, your trial shows here in a few seconds.";
/** The button beside `CHECKOUT_BACK_COPY`: re-reads the subscription from the server. */
exports.CHECKOUT_CHECK_AGAIN_COPY = "Check again";
//# sourceMappingURL=checkoutLinkOutCopy.js.map